export default __webpack_public_path__ + "static/media/products-icon-default.7309f4a2.svg";